module.exports = __webpack_public_path__ + "static/media/image011.26afeeae.jpg";